'use client';

import clsx from 'clsx';

interface IMatchStatus {
  variant?:
    | 'READY_FOR_EXECUTION'
    | 'IN_PROGRESS'
    | 'DECLARABLE'
    | 'CANCELLED'
    | 'NO_SHOW'
    | 'SUBSTITUTED'
    | 'COMPLETED';
  children: React.ReactNode;
}

const defaultGreyBadge = 'text-labels-darkGreyText bg-labels-darkGreyBackground border-labels-darkGreyText border';

const variantStyle = {
  READY_FOR_EXECUTION: defaultGreyBadge,
  IN_PROGRESS: defaultGreyBadge,
  DECLARABLE: defaultGreyBadge,
  CANCELLED: defaultGreyBadge,
  NO_SHOW: 'text-labels-redText bg-labels-redBackground border-labels-redText border',
  SUBSTITUTED: defaultGreyBadge,
  COMPLETED: 'text-labels-greenText bg-labels-greenBackground border-labels-greenText border',
  CLAIMABLE: defaultGreyBadge,
  CLAIM_PENDING: defaultGreyBadge,
  CLAIM_DISPUTED: defaultGreyBadge,
  CLAIMED: defaultGreyBadge,
};

export const MatchStatus = ({ variant = 'COMPLETED', children }: IMatchStatus) => {
  const classNames = clsx(
    'size-2 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium',
    variantStyle[variant],
  );

  return <span className={classNames}>{children}</span>;
};

MatchStatus.displayName = 'MatchStatus';
